import { render, staticRenderFns } from "./kats.vue?vue&type=template&id=8409b412&"
import script from "./kats.vue?vue&type=script&lang=js&"
export * from "./kats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports